/* import __COLOCATED_TEMPLATE__ from './description.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();